import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { initialAsyncReduxState } from '../../constants';
import { AsyncReduxState } from '../../types';

export type SchoolExperienceState = AsyncReduxState<{
    createIsSuccessful: boolean;
    updateIsSuccessful: boolean;
    deleteIsSuccessful: boolean;
}>;

const initialState: SchoolExperienceState = {
    ...initialAsyncReduxState,
    createIsSuccessful: false,
    updateIsSuccessful: false,
    deleteIsSuccessful: false,
};

export const schoolExperienceSlice = createSlice({
    name: 'schoolExperienceReducer',
    initialState,
    reducers: {
        setIsLoading(state, action: PayloadAction<boolean>): SchoolExperienceState {
            return {
                ...state,
                isLoading: action.payload,
            };
        },
        setIsSuccessful(state, action: PayloadAction<boolean>): SchoolExperienceState {
            return {
                ...state,
                isSuccessful: action.payload,
            };
        },
        setCreateIsSuccessful(state, action: PayloadAction<boolean>): SchoolExperienceState {
            return {
                ...state,
                createIsSuccessful: action.payload,
            };
        },
        setUpdateIsSuccessful(state, action: PayloadAction<boolean>): SchoolExperienceState {
            return {
                ...state,
                updateIsSuccessful: action.payload,
            };
        },
        setDeleteIsSuccessful(state, action: PayloadAction<boolean>): SchoolExperienceState {
            return {
                ...state,
                deleteIsSuccessful: action.payload,
            };
        },
        setError(state, action: PayloadAction<string>): SchoolExperienceState {
            return {
                ...state,
                error: action.payload,
            };
        },
    },
});

export const {
    setIsLoading,
    setIsSuccessful,
    setCreateIsSuccessful,
    setUpdateIsSuccessful,
    setDeleteIsSuccessful,
    setError,
} = schoolExperienceSlice.actions;

export default schoolExperienceSlice.reducer;
